// Meets any minimum value requirements
export function isValidForMin(val, min) {
  return typeof min === 'number' ? val >= min : true;
} // Meets any maximum value requirements

export function isValidForMax(val, max) {
  return typeof max === 'number' ? val <= max : true;
}